export default async function () {
    return lumina?.is_captcha_on_login_signup_form === 'yes' ? await GSApp.getRecaptchaToken() : 1;
};
